module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "id": "voucherPage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险")]), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    staticClass: "already"
  }, [_vm._v("已参保")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 1) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.obj.start_time) + "至2023年9月15日")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保险详细")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "#/range"
    },
    on: {
      "click": _vm.clickRange
    }
  }, [_vm._v("保障范围")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("服务热线")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "tel:4009999595"
    },
    on: {
      "click": _vm.range
    }
  }, [_vm._v("400-999-9595")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "width": "100%",
      "margin-top": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "bottom_btn",
    class: {
      halfwidth: _vm.claimList
    },
    attrs: {
      "id": "btn_claim"
    },
    on: {
      "click": _vm.goClaim
    }
  }, [_vm._v("我要索赔")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.claimList),
      expression: "claimList"
    }],
    staticClass: "bottom_btn claimList",
    class: {
      halfwidth: _vm.claimList
    },
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": "/claimList"
    }
  }, [_c('div', {
    on: {
      "click": _vm.clickClaimList
    }
  }, [_vm._v("索赔记录")])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("累计最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥100000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("单日/单次最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥20000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付金额")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥0.00元")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2baccd33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/detail.vue
// module id = 816
// module chunks = 1